const formatMoney = (number) => {
    return number.toLocaleString('en-US', {
      maximumFractionDigits: 2,
    });
  };
  
  export default formatMoney;